<div class="dashboard-top-section d-flex align-items-center justify-content-between" *ngIf="isPageInitialized">
  <h1 class="secondary">{{ 'fuelDashboard.page.title' | transloco }}</h1>

  <div class="search-menu-lists d-flex">
    <div class="filters d-flex align-items-center gap-2">
      <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

      <div class="common-drop-down dropdown date-height dropdown-button">
        <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
          [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
          (filterChanged)="onFuelDashboardDateFilterChange($event)">
        </app-date-filter>
      </div>

      <!-- <div class="export-listing">
        <div class="common-drop-down dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
            aria-expanded="false">
            Export <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdown-button">
            <li><a class="dropdown-item">Export as pdf</a></li>
            <li><a class="dropdown-item">Export as csv</a></li>
            <li><a class="dropdown-item">Send via email</a></li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="dashboard-box">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 dashboard-column">
      <app-fuel-consumption-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-fuel-consumption-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 dashboard-column">
      <app-total-decrease-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-total-decrease-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 dashboard-column">
      <app-reconciliation-variant-widget
        [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-reconciliation-variant-widget>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-12 dashboard-column">
      <app-fuel-cost-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)"></app-fuel-cost-widget>
    </div>
  </div>

  <div class="map-wrapper">
    <div class="graph-box-main">
      <div class="graph-box-left">
        <div class="row graph-box-row">
          <div class="col-lg-6 col-md-6 col-sm-12 graph-box">
            <app-fuel-consumption-widget-graph [widgetExpandable]="false"></app-fuel-consumption-widget-graph>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 graph-box">
            <app-total-decrease-widget-graph [widgetExpandable]="false"></app-total-decrease-widget-graph>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 graph-box">
            <app-reconciliation-variant-widget-graph></app-reconciliation-variant-widget-graph>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12 graph-box">
            <app-fuel-cost-widget-graph></app-fuel-cost-widget-graph>
          </div>
        </div>
      </div>

      <div class="right-map-box">
        <app-fuel-dashboard-map [mapCenter]="mapCenter" [isLoading]="isLoadingLocations"></app-fuel-dashboard-map>
      </div>
    </div>
  </div>